export const SOFTLINE_API_KUNDE_TEMPLATE = '/v1/neukunde/template'
export const SOFTLINE_API_KUNDE_ENTITIES = '/v1/neukunde/entities';
export const SOFTLINE_API_PUBLIC_KUNDE_ENTITIES = '/v1/public/neukunde/entities';
export const SOFTLINE_API_PUBLIC_KUNDE_TEMPLATE = '/v1/public/neukunde/template';
export const SOFTLINE_API_PUBLIC_COUNTRY_CODES = '/v1/public/countrycodes';
